import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=7ad33535&scoped=true&"
import script from "./RegionList.vue?vue&type=script&lang=js&"
export * from "./RegionList.vue?vue&type=script&lang=js&"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=7ad33535&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad33535",
  null
  
)

export default component.exports